var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.697,
    height: 14.325,
    viewBox: "0 0 7.697 14.325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Arrow_2333164",
    transform: "translate(7.697) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35458",
    "data-name": "Group 35458",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63867",
    "data-name": "Path 63867",
    d: "M6.541,7.45.257,1.457a.841.841,0,0,1,0-1.211.936.936,0,0,1,1.265,0l5.64,5.4L12.8.246a.935.935,0,0,1,1.265,0,.841.841,0,0,1,0,1.211L7.806,7.45A.935.935,0,0,1,6.541,7.45Z",
    fill: "#233d64",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowBtn);
export default __webpack_public_path__ + "static/media/leftArrowBtn.ae124319bc47ee22b119d48358993200.svg";
export { ForwardRef as ReactComponent };